// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import { imageStyles } from "@insite/content-library/Widgets/Basic/Image";
import { css } from "styled-components";

imageStyles.imageLink = {
    css: css`
        box-shadow: 0 1px 3px 2px transparent;
        transition: box-shadow 200ms ease-in-out;
        &:hover {
            box-shadow: 0 1px 3px 2px ${color("primary.main", 0.35)};
        }
        &:focus-visible {
            outline: 1px solid ${color("primary")};
        }
    `,
};
